/*
 * @Description: 
 * @Autor: tanglitong
 * @Date: 2021-01-29 16:33:40
 * @LastEditors: tanglitong
 * @LastEditTime: 2021-07-29 17:02:36
 */

import store from '../store/index.js'
import { Base64 } from 'js-base64'

/**
 * @description: 关闭当前页面/关闭当前窗口
 */
export const CloseWebPage = () => {
  if (navigator.userAgent.indexOf('MSIE') > 0) {
    if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
      window.opener = null
      window.close()
    } else {
      window.open('', '_top')
      window.top.close()
    }
  } else if (navigator.userAgent.indexOf('Firefox') > 0) {
    window.location.href = 'about:blank '
  } else {
    window.opener = null
    window.open('', '_self', '')
    window.close()
  }
}

/**
 * @description: 人脸识别sessionStorage数据操作
 */
export const FaceRecognitionStorage = {
  /**
   * @description: 获取所有属于人脸识别标记的数据
   */
  getFRSData: () => {
    const len = sessionStorage.length
    let arr = []
    for (var i = 0; i < len; i++) {
      var getKey = sessionStorage.key(i)
      var getVal = sessionStorage.getItem(getKey)
      if (getKey.includes(process.env.VUE_APP_FRSIGN)) {
        arr.push({'key': getKey, 'value': getVal})
      }
    }
    return arr
  },
  /**
   * @description: 删除所有属于人脸识别标记的数据
   */
  delFRSData: () => {
    const frs = FaceRecognitionStorage.getFRSData()
    for (let i = 0; i < frs.length; i++) {
      const ek = frs[i].key
      sessionStorage.removeItem(ek)
    }
  }
}

/**
 * @description: 清除local标记
 */
export const cleanLocalSign = () => {
  const userId = store.state.user.userInfo && store.state.user.userInfo.id
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    // 清除通知
    if (key.includes(`${ process.env.VUE_APP_APPKEY }${ userId }`)) {
      localStorage.removeItem(key)
    }
  }
}
export const Deviceinfo = (browsertabid) => {
  // 获取设备信息
  let deviceinfo = {
    deviceid: localStorage.getItem('FingerprintID'),
    devicetype: 'pc',
    devicename: window.navigator.userAgent,
    vername: '',
    vercode: '',
    sysver: '',
    platform: '医博士',
    uuid: store.state.user.userInfo ? store.state.user.userInfo.uuid : '',
    browsertabid: browsertabid
  }
  return Base64.encode(JSON.stringify(deviceinfo))
}
//生成uuid  
export const createUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}  



// WEBPACK FOOTER //
// ./src/utils/global-methods.js